import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_footervue = _resolveComponent("footervue")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        color: "primary",
        prominent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, {
            variant: "text",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.drawer = !_ctx.drawer), ["stop"]))
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_navigation_drawer, {
        modelValue: _ctx.drawer,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.drawer) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oflineLinks, (i) => {
                return _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                  key: i.text,
                  "prepend-icon": i.icon,
                  title: i.text,
                  to: { name: i.router }
                }, null, 8, ["prepend-icon", "title", "to"])), [
                  [_vShow, !_ctx.isloged]
                ])
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logedUserLinkes, (i) => {
                return _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                  key: i.text,
                  "prepend-icon": i.icon,
                  title: i.text,
                  to: { name: i.router }
                }, null, 8, ["prepend-icon", "title", "to"])), [
                  [_vShow, _ctx.isloged]
                ])
              }), 128)),
              _withDirectives(_createVNode(_component_v_list_item, {
                onClick: _ctx.logout,
                "prepend-icon": "mdi-logout",
                title: "Sair"
              }, null, 8, ["onClick"]), [
                [_vShow, _ctx.isloged]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_footervue)
    ]),
    _: 1
  }))
}